import { Select } from 'components/v2/Select'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { ISelectPassengerTypeProps } from './types'
import { PASSENGER_TYPE } from 'features/Bookings/components/PassengerType/constants'

const messages = defineMessages({
  selectPassengerType: {
    id: 'passengerType.new.form.selectPassengerType',
    defaultMessage: 'Choose passenger type'
  }
})

const PASSENGER_TYPES_OPTIONS = [
  PASSENGER_TYPE.ADULT,
  PASSENGER_TYPE.SENIOR,
  PASSENGER_TYPE.CHILD,
  PASSENGER_TYPE.PET
] as const

const passengerTypeMessages = defineMessages({
  [PASSENGER_TYPE.ADULT]: {
    id: 'dictionary.adult',
    defaultMessage: 'Adult'
  },
  [PASSENGER_TYPE.SENIOR]: {
    id: 'dictionary.senior',
    defaultMessage: 'Senior'
  },
  [PASSENGER_TYPE.CHILD]: {
    id: 'dictionary.child',
    defaultMessage: 'Child'
  },
  [PASSENGER_TYPE.PET]: {
    id: 'dictionary.pet',
    defaultMessage: 'Pet'
  }
})

export const SelectPassengerType = ({
  value,
  onBlur,
  touched,
  errors,
  disabled,
  onChange
}: ISelectPassengerTypeProps): ReactElement => {
  const intl = useIntl()

  return (
    <Select
      id="selectPassengerType"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
        onChange(e.target.value)
      }}
      onBlur={onBlur}
      touched={touched}
      errors={errors}
      label={<FormattedMessage id="dictionary.passengerType" defaultMessage="Passenger Type" />}
      disabled={disabled}
    >
      <option value="">{intl.formatMessage(messages.selectPassengerType)}</option>

      {PASSENGER_TYPES_OPTIONS.map((option) => {
        return (
          <option key={option} value={option}>
            {passengerTypeMessages[option] ? intl.formatMessage(passengerTypeMessages[option]) : option}
          </option>
        )
      })}
    </Select>
  )
}
